module.exports = __webpack_public_path__ + "static/media/logo-method.821cce38.png";